import * as React from 'react';
const SvgRadioOff = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, fill: "none" }, props),
    React.createElement("path", { fill: "#E1E1E1", fillOpacity: 0.8, d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11Z" })));
export default SvgRadioOff;
